<div class="mt-filter filter-machine">
    <div class="title">
        <span class="label">{{'machines' | lang}}</span>
        <span *ngIf="filter.required" class="mandatory">*</span>
    </div>

    <div class="filter">
        <app-dropdown-selector
            label=""
            [items]="machines"
            bindLabel="name"
            bindValue="machineId"
            [multiselect]="filter.multiselect ? true : false"
            [allSelectedOption]="filter.multiselect ? true : false"
            [ngModel]="selectedOption"
            (ngModelChange)="changeSelectedOption($event)">
        </app-dropdown-selector>
    </div>
</div>